import { convertToNumber } from '@/utils/converts';
import { formattedDate } from '@/utils/formatting';
export default {
  state: {
    solicitation: '',

    step: 1,
    solicitationPatient: {},
    solicitationProcedure: {
      procedurePPPType: '',
    },
    solicitationProtocol: {},
    solicitationAttachments: [],
    solicitationObservations: [],
    solicitationClinicalSummary: {
      clinicalSummary: '',
    },

    attachment: {},
    observation: '',

    solicitationsFilters: {},
    regulatedPatientsFilters: {},
    solicitationFiltersData: {},
  },

  getters: {
    getSolicitation(state) {
      return state.solicitation;
    },

    getSolicitationStep(state) {
      return state.step;
    },

    getSolicitationPatient(state) {
      return state.solicitationPatient;
    },

    getSolicitationProcedure(state) {
      return state.solicitationProcedure;
    },

    getSolicitationProtocol: (state) => state.solicitationProtocol,

    getSolicitationAttchments(state) {
      return state.solicitationAttachments;
    },

    getSolicitationObservations(state) {
      return state.solicitationObservations;
    },

    getSolicitationAttchment(state) {
      return state.attachment;
    },

    getSolicitationObservation(state) {
      return state.observation;
    },

    getSolicitationClinicalSummary(state) {
      return state.solicitationClinicalSummary;
    },

    getSolicitationsFilters: (state) => state.solicitationsFilters,
    getRegulatedPatientsFilters: (state) => state.regulatedPatientsFilters,
    getSolicitationFiltersData: (state) => state.solicitationFiltersData,
  },

  mutations: {
    setSolicitation(state, data) {
      state.solicitation = data;
    },

    setSolicitationStep(state, step) {
      state.step = step;
    },

    setSolicitationPatient(state, data) {
      const isCreate = data?.id;

      state.solicitationPatient = {
        codigo: isCreate ? data.id : data.patient_codigo,
        name: data.name,
        cns: data.cns,
        cpf: data.cpf,
        birthDate: data.birth_date,
        motherName: data.mother_name,
        codigoIbge: data.codigo_ibge,
        sexId: data.sex_id,
        isJudicial: data.is_judicial,
        judicialDemand: isCreate ? '' : convertToNumber(data.judicialDemand),
      };

      if (!state.solicitationPatient.birthDate) {
        state.solicitationPatient = {
          ...state.solicitationPatient,
          birthDate: formattedDate(data.date_birth),
          sex: data.sex,
        };
      }
    },

    setSolicitationProcedure(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.solicitationProcedure = {
        scheduleType: isUpdate ? parseInt(data.type_schedules_id) : '',
        isLU: false,
        idLU: '',
        dateLU: '',

        procedurePPP: isUpdate ? data.co_procedimento : '',
        procedureGroup: isUpdate ? data.group_procedure_id : '',
        procedurePPPType: isUpdate ? parseInt(data.procedure_type_id) : '',
        patientStatus: isUpdate ? parseInt(data.patient_status_id) : '',
        transporteType: isUpdate ? parseInt(data.transport_type_id) : '',
        hospitalSector: isUpdate ? data.hospital_sector : '',

        procedure: isUpdate ? data.co_procedimento : '',
        occupation: isUpdate ? data.co_ocupacao : '',
        subOccupation: isUpdate ? data.co_sub_occupation : '',
        diagnostic: isUpdate ? data.co_diagnosis : '',
        cid: isUpdate ? data.code_cid : '',
        cidName: isUpdate ? data.name_cid : '',

        protocolPPPId: isUpdate ? data.protocol_ppp_image_id : '',
        protocolPPP: isUpdate ? data.protocol_ppp_image : '',
        protocolAmbulatoryId: isUpdate ? data.protocol_ambulatory_id : '',
        protocolAmbulatory: isUpdate ? data.protocol_ambulatory : '',
        protocolAgressId: isUpdate ? data.protocol_egress_id : '',
        protocolAgress: isUpdate ? data.protocol_egress : '',
        protocolOncologyId: isUpdate ? data.protocol_oncology_id : '',
        protocolOncology: isUpdate ? data.protocol_oncology : '',
        attendance_restriction: isUpdate ? data.attendance_restriction : '',

        isUpdate: isUpdate,
      };
    },

    setSolicitationProtocol(state, protocol) {
      state.solicitationProtocol = protocol;
    },

    setSolicitationAttachments(state, data) {
      state.solicitationAttachments = data;
    },

    setSolicitationAttachment(state, attachment) {
      state.attachment = attachment;
    },

    setSolicitationObservations(state, observations) {
      state.solicitationObservations = observations;
    },

    setSolicitationObservation(state, observation) {
      state.observation = observation;
    },

    setSolicitationClinicalSummary(state, clinicalSummary) {
      state.solicitationClinicalSummary.clinicalSummary = clinicalSummary;
    },

    setSolicitationsFilters(state, filters) {
      state.solicitationsFilters = filters;
    },

    setRegulatedPatientsFilters(state, filters) {
      state.regulatedPatientsFilters = filters;
    },

    setSolicitationFiltersData(state, data) {
      state.solicitationFiltersData = data;
    },
  },

  actions: {
    changeSolicitationStep(context, step) {
      context.commit('setSolicitationStep', step);
    },

    changeSolicitationPatient(context, data) {
      context.commit('setSolicitationPatient', data);
    },

    changeSolicitationProcedures(context, data) {
      context.commit('setSolicitationProcedure', data);
    },

    changeSolicitationProtocol(context, protocol) {
      context.commit('setSolicitationProtocol', protocol);
    },

    changeSolicitationAttachments(context, data) {
      context.commit('setSolicitationAttachments', data);
    },

    changeSolicitationAttachment(context, attachment) {
      context.commit('setSolicitationAttachment', attachment);
    },

    changeSolicitationObservations(context, observations) {
      context.commit('setSolicitationObservations', observations);
    },

    changeSolicitationObservation(context, observation) {
      context.commit('setSolicitationObservation', observation);
    },

    changeSolicitationClinicalSummary(context, clinicalSummary) {
      context.commit('setSolicitationClinicalSummary', clinicalSummary);
    },

    //
    changeSolicitation(context, data) {
      context.commit('setSolicitation', data);
      context.commit('setSolicitationPatient', {
        ...data,
        id: data.patient_codigo,
      });
      context.commit('setSolicitationProcedure', data);

      if (data.type_schedules_id === '1') {
        context.commit('setSolicitationAttachments', data.file_solicitacions);
      } else if (data.type_schedules_id === '2') {
        context.commit(
          'setSolicitationAttachments',
          data.file_protocol_ppp_image,
        );
      } else if (data.type_schedules_id === '3') {
        context.commit(
          'setSolicitationAttachments',
          data.file_protocol_egresses,
        );
      } else if (data.type_schedules_id === '4') {
        context.commit(
          'setSolicitationAttachments',
          data.file_protocol_oncology,
        );
      }

      context.commit('setSolicitationObservations', data.obs_solicitacions);
      context.commit('setSolicitationClinicalSummary', data.clinical_summary);
    },

    changeSolicitationsFilters(context, filters) {
      context.commit('setSolicitationsFilters', filters);
    },

    changeRegulatedPatientsFilters(context, filters) {
      context.commit('setRegulatedPatientsFilters', filters);
    },

    changeSolicitationFiltersData(context, data) {
      context.commit('setSolicitationFiltersData', data);
    },
  },
};
